<div class="header-wrapper">
  <div class="header-content flex">
    <img
      src="assets/images/repricing/repricing_solute_logo.png"
      width="175px"
      class="cursor-pointer"
      (click)="navigateToHome()"
    />

    <div class="langs-wrapper">
      <div
        class="lang-item"
        [ngClass]="selectedLanguage()?.code === 'en' ? 'lang-item--active' : ''"
        (click)="changeLanguage('en')"
      >
        <img src="assets/images/flags/flag_GB.svg" /> En
      </div>
      <div
        class="lang-item"
        [ngClass]="selectedLanguage()?.code === 'de' ? 'lang-item--active' : ''"
        (click)="changeLanguage('de')"
      >
        <img src="assets/images/flags/flag_DE.svg" /> DE
      </div>
    </div>
    @if (isLoggedin()) {
      <div class="border-l border-darkColor ml-2 pl-2">
        <em-icon-button
          color="danger"
          icon="power_settings_new"
          [matTooltip]="'ACTIONS_LOGOUT' | translate"
          (btnClick)="logout()"
        ></em-icon-button>
      </div>
    }
  </div>
</div>
<router-outlet></router-outlet>
